import React, { useEffect } from "react";
import { Form, Select, Typography, Row, Col, Checkbox } from "antd";

import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

// Mirrors the server enum it.polimi.lode.model.building.NonOrdinarySubtype.
// Labels are English; i18n later.
const NON_ORDINARY_SUBTYPES = [
    { value: "LARGE_SPAN",                label: "Large-span structure" },
    { value: "CULTURAL_HERITAGE_CHURCH",  label: "Cultural heritage — church" },
    { value: "CULTURAL_HERITAGE_PALACE",  label: "Cultural heritage — palace" },
    { value: "OTHER",                     label: "Other" },
];

const NonOrdinaryBuildingForm = props => {
    const [form] = Form.useForm();
    const isEditMode = props.isEditMode || false;

    const formItemLayout = {
        labelCol: { sm: { span: 8 } },
        wrapperCol: { sm: { span: 16 } },
    };

    useEffect(() => {
        if (props.record.enterprise) {
            form.setFieldsValue({
                subtype: props.record.enterprise.subtype,
                culturalHeritage: props.record.enterprise.culturalHeritage || false,
                heritageTier: props.record.enterprise.heritageTier,
            });
        }
    }, [props.record.enterprise, form]);

    const onValuesChange = (changedValues) => {
        form.validateFields(Object.keys(changedValues));
    };

    const onFieldsChange = () => {
        if (!isEditMode) return;

        const values = form.getFieldsValue();
        let valid = true;
        if (!form.getFieldsError().every(e => e === undefined || e.errors.length === 0)) {
            valid = false;
        }

        const newData = { ...props.record };
        newData.enterprise.subtype = elvis(values.subtype);
        newData.enterprise.culturalHeritage = values.culturalHeritage || false;
        newData.enterprise.heritageTier = values.culturalHeritage ? elvis(values.heritageTier) : null;
        newData.valid = valid;
        props.parentCallback(newData);
    };

    return (
        <Form
            form={form}
            {...formItemLayout}
            className="details_form"
            onValuesChange={onValuesChange}
            onFieldsChange={onFieldsChange}
        >
            <Row>
                <Col span={11}>
                    <Title level={4}>Classification</Title>
                    <Form.Item
                        label="Subtype"
                        name="subtype"
                        rules={isEditMode ? [{ required: true, message: 'Please select a subtype' }] : []}
                    >
                        <Select disabled={!isEditMode}>
                            {NON_ORDINARY_SUBTYPES.map(opt => (
                                <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Title level={4}>Cultural heritage</Title>
                    <Form.Item
                        label="Cultural heritage"
                        name="culturalHeritage"
                        valuePropName="checked"
                    >
                        <Checkbox disabled={!isEditMode} />
                    </Form.Item>
                    <Form.Item
                        noStyle
                        shouldUpdate={(prev, curr) => prev.culturalHeritage !== curr.culturalHeritage}
                    >
                        {({ getFieldValue }) => getFieldValue('culturalHeritage') ? (
                            <Form.Item label="Heritage tier" name="heritageTier">
                                <Select disabled={!isEditMode} allowClear>
                                    <Option value="WORLD_HERITAGE">World Heritage</Option>
                                    <Option value="HAGUE_CONVENTION">Hague Convention</Option>
                                    <Option value="NATIONAL">National</Option>
                                    <Option value="SUB_NATIONAL">Sub-national</Option>
                                    <Option value="LOCAL">Local</Option>
                                </Select>
                            </Form.Item>
                        ) : null}
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default NonOrdinaryBuildingForm;
